import { useMemo } from 'react';
import { contactLinks } from '../data/contactLinks';
// import { stats } from '../data/stats';
// import { useCountUp } from '../hooks/useCountUp';
import { useScrollReveal } from '../hooks/useScrollReveal';

// const StatCard = ({ label, value, active }) => {
//   const count = useCountUp(value, active);

//   return (
//     <div className="hero-stat-card">
//       <h3>{`${count}+`}</h3>
//       <p>{label}</p>
//     </div>
//   );
// };

const heroImages = [
  {
    src: '/img/service/web.jpg',
    alt: 'Wedding Website Preview',
    className: 'hero-media hero-media--primary',
  },
  {
    src: '/img/hero/rsvp.jpg',
    alt: 'Digital Wedding Card',
    className: 'hero-media hero-media--secondary',
  },
  {
    src: '/img/service/chatbot.jpg',
    alt: 'Wedding Chatbot',
    className: 'hero-media hero-media--tertiary',
  },
];

export const Hero = () => {
  const [copyRef, copyVisible] = useScrollReveal();
  const [visualRef, visualVisible] = useScrollReveal({ threshold: 0.1 });

  // const statsToRender = useMemo(() => stats.slice(0, 2), []);
  const featuredContacts = useMemo(() => contactLinks.filter((contact) => contact.featured), []);

  return (
    <section id="home" className="hero-section">
      <div className="hero-backdrop" aria-hidden="true">
        <div className="hero-gradient" />
        <div className="hero-orb hero-orb--one" />
        <div className="hero-orb hero-orb--two" />
        <div className="hero-orb hero-orb--three" />
      </div>

      <div className="container">
        <div className="hero-layout">
          <div ref={copyRef} className={`hero-copy fade-section ${copyVisible ? 'is-visible' : ''}`}>
            <span className="hero-eyebrow">Welcome to Wedding Tech</span>
            <h1>Digital Wedding Solution</h1>
            <p>
              Everything you need for your big day — personalized website, digital invitations, RSVP tracking,
              AI-powered chatbot, guest wishes, and even payment verification. All in one place.
            </p>
            <div className="hero-actions">
              <a className="btn btn-primary btn-lg" href="#services">
                <span className="btn-icon" aria-hidden="true">
                  <i className="fas fa-star" />
                </span>
                <span>Explore Services</span>
              </a>
              <a className="btn btn-outline-primary btn-lg" href="#success-stories">
                View Success Stories
              </a>
            </div>
            {/* <div className="hero-stats">
              {statsToRender.map((stat) => (
                <StatCard key={stat.id} label={stat.label} value={stat.value} active={copyVisible} />
              ))}
            </div> */}
            <div className="hero-connect">
              <span className="hero-connect__label">Connect with us</span>
              <div className="contact-links contact-links--compact">
                {featuredContacts.map((contact) => (
                  <a
                    key={contact.id}
                    className="contact-link contact-link--compact"
                    href={contact.href}
                    target={contact.external ? '_blank' : undefined}
                    rel={contact.external ? 'noopener noreferrer' : undefined}
                    aria-label={`${contact.label}: ${contact.display}`}
                  >
                    <span className="contact-link__icon" aria-hidden="true">
                      <i className={contact.iconClass} />
                    </span>
                    <span className="contact-link__label">{contact.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div ref={visualRef} className={`hero-visual fade-section ${visualVisible ? 'is-visible' : ''}`}>
            <div className="hero-gallery">
              {heroImages.map((image) => (
                <figure key={image.src} className={image.className}>
                  <img src={image.src} alt={image.alt} loading="lazy" />
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
